import { render } from "./OpeningHours.vue?vue&type=template&id=7b902f8c"
import script from "./OpeningHours.vue?vue&type=script&lang=js"
export * from "./OpeningHours.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__